export default __webpack_public_path__ + "static/3-dd4938a5b6ed0d47ea5c2226a7098661.jpeg";